<sm-svg-loader *ngIf="loader"></sm-svg-loader>

<div class="dashboard_new" *ngIf="!loader && employeeLogData.length == 0">
    <mat-card>
        <div class="upload_sectio">
       <div class="icm_img">
          <img src="./assets/images/s3.png">
       </div>
       <mat-card-title>Your employee's In & Out data</mat-card-title>
       <mat-card-content>Knowing when employees start and stops works helps business owners allocate tasks more efficiently. It gives real-time data on which employees are present and who are absent. 
      </mat-card-content>
       <!-- <div class="watch_vc_btn">
          <button mat-stroked-button color="primary" (click)="openvideo()">
             <mat-icon>smart_display</mat-icon>
             Watch video
          </button>
       </div> -->
       </div>
    </mat-card>
 </div>

 <!-- with data -->

 <div class="today_booking_card" *ngIf="!loader && employeeLogData.length > 0">
    <mat-card>
    <div class="vier_tht">
       <div class="heading_ot">
       <h3>Employee In/Out</h3> 
      </div>
       <div class="view_all_btn" *ngIf="employeeLogData[0]?.total_count > 4">
        <a (click)="viewAll()">{{employeeLogData[0]?.total_count > 4 ? 'View all ' + employeeLogData[0]?.total_count : 'View details'}}</a>
      </div>
  </div>

  <div class="list_yy" *ngFor="let item of employeeLogData">
    <div class="bookign_img">
    <img [src]="item.image_thumb_url" onerror="this.src='../../../../../../assets/images/user-avatar.svg'" alt=""/>
    </div>
    <div class="booking_heading">
        <h3>{{item.name}}</h3>
        <p>{{item.phone}}</p>
    </div>
    <div class="booking_heading">
        <h3>{{item.business_name}}</h3>
        <p>{{item.address_line}}</p>
    </div>
    <div class="booking_heading">
        <h3>{{item.duty_time | date: "shortTime":'UTC'}}</h3>
    </div>
    <div class="status_heading">
     <p style="width: fit-content !important;" [class.make-text-green]="item.entry_type == 1" [class.make-text-red]="item.entry_type == 0">{{item.entry_status}}</p>
    </div>
  </div>
  <div class="list_yy" style="height: 61px;" *ngFor="let item of repeatArray">
    
  </div>

 

 
</mat-card>

</div>